module.exports = __webpack_public_path__ + "static/media/buy_req_teach_6.46eabcff.jpg";